import {until} from 'lit-html/directives/until';
import {permissions, modals, productKeepGrayScale} from '../constants-enumerate';
import {hasOneOfPermissions} from '../permissions';
import '../../modules/auth-context';
import '../../modules/show-modal';
import {products as productConsts, productLogos} from '../constants-enumerate';
import {generalLabels} from '@modules/i18n-labels';

const PASSCODE_PRODUCTS = {
  [productConsts.ABCMOUSE]: true,
  [productConsts.MATH_ACADEMY]: true,
  [productConsts.READING_MASTERY]: true,
  [productConsts.MY_MATH_ACADEMY]: true,
  [productConsts.MY_READING_ACADEMY]: true,
};

export default (ctx, html) => html`
  <div class="product-info-card card card-border-color-left card-border-color-success card border-top-0 border-bottom-0 border-right-0 shadow-sm">
    <div class="card-header font-weight-semibold">
      <img alt="${ctx.product.product}"
           src="${productLogos[ctx.product.product].icon.active}"
           width="${productLogos[ctx.product.product].icon.width}"
           height="${productLogos[ctx.product.product].icon.height}"
           class="${productKeepGrayScale.includes(ctx.product.product) ? 'black-img' : ''}"
      />
    </div>
    <div class="card-body">
      <div class="row">
        ${ctx.product.status !== 'potential' ?
          html`
            ${renderTerminationDate(ctx, html)}
            ${renderRedeemCode(ctx, html)}
            ${renderInviteStatus(ctx, html)}
            ${renderRedeemDate(ctx, html)}
            ${renderFspk(ctx, html)}
            ${renderPasscode(ctx, html)}
          ` : ``}
      </div>
      ${ctx.product.status !== 'potential' ?
        html`${renderRevokeAction(ctx, html)}` :
        ``}
      ${ctx.product.activation_status === 'unactivated' && ctx.product.status !== 'potential' && ctx.product.external_access_type !== 'none' ? html`<slot name="invite-text"></slot>` : ''}
    </div>
  </div>
`;

const renderFspk = (ctx, html) => {
  if (!ctx.product.fspk) {
    return '';
  }

  return html`
    <div class="col-6 col-sm-12 col-md-6">
      <p class="text-muted mb-0">FSPK</p>
      <p>${until(generalLabels.Yes)}</p>
    </div>`;
};

const renderRedeemCode = (ctx, html) => {
  if (!ctx.product.redeem_code || ctx.product.activation_status !== 'unactivated') {
    return '';
  }

  return html`
    <div class="col-6 col-sm-12 col-md-6">
      <p class="text-muted mb-0">${until(ctx.__('<tt-RicfQZfe>', 'Redeem Code'))}</p>
      <p>${ctx.product.redeem_code}</p>
    </div>`;
};

const renderRedeemDate = (ctx, html) => {
  if (ctx.product.activation_status === 'unactivated' || !ctx.product.redeemDate) {
    return;
  }

  return html`
    <div class="col-6 col-sm-12 col-md-6">
      <p class="text-muted mb-0">${until(ctx.__('<tt-AKcrscJB>', 'Redeem Date'))}</p>
      <p>${ctx.product.redeemDate}</p>
    </div>
  `;
};

const renderTerminationDate = (ctx, html) => {
  if (ctx['user-type'] !== 'student' || !ctx.product.licenseEndDate) {
    return;
  }

  return html`
    <div class="col-6 col-sm-12 col-md-6">
      <p class="text-muted mb-0">${until(ctx.__('<tt-HTAqzOcF>', 'License Start Date'))}</p>
      <p>${ctx.product.licenseStartDate}</p>
    </div>

    <div class="col-6 col-sm-12 col-md-6">
      <p class="text-muted mb-0">${until(ctx.__('<tt-hz9qaHYU>', 'Terminate Date'))}</p>
      <p>${ctx.product.licenseEndDate}</p>
    </div>`;
};

const renderInviteStatus = (ctx, html) => {
  if (ctx.product.external_access_type === 'none' || !(ctx.product.activation_status === 'unactivated' && ctx['user-type'] === 'student')) {
    return;
  }

  let content;
  if (ctx.product.invitation_status === 'not_sent') {
    content = html`
      <p class="text-muted mb-0">${until(ctx.__('<tt-PAvI9Vqo>', 'Invitation Status'))}</p>
      <p>${until(ctx.__('<tt-AU2Eed47>', 'Not Sent'))}</p>`;
  } else if (ctx.product.status !== 'active') {
    content = html`
      <p class="text-muted mb-0">${until(ctx.__('<tt-+hJ+3xAE>', 'Invitation Status'))}</p>
      <p>${until(ctx.__('<tt-nrk+cEkD>', 'Sent (Not Redeemed)'))}</p>`;
  }

  return html`<div class="col-6 col-sm-12 col-md-6">${content}</div>`;
};

const renderRevokeAction = (ctx, html) => {
  if (!(ctx['user-type'] === 'student' && ctx.product.status !== 'inactive')) {
    return;
  }

  return html`
    <auth-context show-on-auth .permissions="${[permissions.LICENSE_APPLY]}">
      <show-modal role="button" tabindex="0" class="btn btn-link" modal-id="${modals.LICENSE_REVOKE}" .modal-data="${{product: ctx.product}}" ?disabled="${!hasOneOfPermissions([permissions.LICENSE_APPLY])}">${until(ctx.__('<tt-auWg+nkF>', 'Revoke'))}</show-modal>
    </auth-context>`;
};

const renderIcon = (ctx, html, id) => {
  if (!ctx.passcodeInfo.passcode_icon_info) {
    return;
  }

  const passcodeItem = ctx.passcodeInfo.passcode_icon_info[id];
  return html`<img width="48" class="d-inine pl-1 pr-1 icon" alt="" src="https://content.abcmouse.com/${passcodeItem.path.svg}" />`;
};

const renderPasscode = (ctx, html) => {
  if (PASSCODE_PRODUCTS[ctx.product.product] && ctx.product.passcode?.length > 0) {
    return html`
      <div class="col-12">
        <p class="text-muted mb-0">${until(ctx.__('<tt-fqpKBsuq>', 'Passcode'))}</p>
        <p>${ctx.product.passcode.map((id) => renderIcon(ctx, html, id))}
          <auth-context class="d-block" show-on-auth .permissions="${[permissions.STUDENT_EDIT]}" .restricted="${[permissions.SPONSOR, permissions.HIDE_STUDENT]}">
            <show-modal
              role="button"
              tabindex="0"
              modal-id="${modals.ABCMOUSE_PASSCODE_RESET}"
              .modal-data="${{student: ctx.student, product: ctx.product.product, successCallback: () => { ctx.clearABCmousePassCode(); }}}"
              class="btn d-inline btn-link">${until(ctx.__('<tt-+Py6LjHx>', 'Reset'))}
            </show-modal>
          </auth-context>
        </p>
      </div>
    `;
  }

  return '';
};
